import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

const FUNCTION_NAME = 'customOLTextStart';

// ******************************************
//     番号付きstart属性変更（テキストボックス）
// ******************************************
export class CustomOLTextStart extends Plugin {
  init() {
    const editor = this.editor;

    editor.ui.componentFactory.add(FUNCTION_NAME, () => {
      const button = new ButtonView();
      const bind = button.bindTemplate;

      button.bind('isEnabled').to(this.editor, 'isReadOnly', (value) => !value);

      // チェックボックス　表示データ
      button.setTemplate({
        tag: 'div',
        children: [
          {
            tag: 'input',
            attributes: {
              type: 'number',
              id: 'txtStart',
              style: [{ width: '40px', 'text-align': 'center', 'background-color': '#ebffff' }],
              value: 2,
              min: 2,
              step: 1,
            },
          },
          {
            tag: 'input',
            attributes: {
              type: 'button',
              id: 'btnStart',
              value: '設定',
              style: [
                { margin: '0px 5px', padding: '0px 5px', 'background-color': '#f2f2f2', border: '1px solid #333' },
              ],
            },
            on: {
              // Views listen to DOM events and propagate them.
              click: bind.to('clicked'),
            },
          },
        ],
      });

      // -----------------------------------------------------
      //   設定ボタン　クリックイベント
      //     テキストボックスの値が数値
      //     数値でない場合、テキストボックスに 1 をセット
      // -----------------------------------------------------
      button.on('clicked', (evt, data) => {
        editor.model.change((writer) => {
          const selection = editor.model.document.selection;
          const blocks = [...selection.getSelectedBlocks()];
          let couldNotSetNumberLines = [];

          blocks.forEach((element, index) => {
            let nodeAttributes = element.getAttribute('htmlPAttributes');
            if (nodeAttributes !== undefined) {
              // console.log('☆彡 htmlPAttributes あり')
              let canSetNumber = editor.customList.canSetNumber(nodeAttributes.classes);
              if (canSetNumber === true) {
                let startValue = document.getElementById('txtStart').value;
                if (startValue && !isNaN(startValue)) {
                  // console.log('☆彡 数値')
                  const oldValue = nodeAttributes;
                  const newValue = structuredClone(oldValue);
                  if (canSetNumber === true) {
                    if (oldValue.attributes && oldValue.attributes.start) {
                      if (startValue !== oldValue.attributes.start) {
                        newValue.attributes.start = startValue;
                      } else {
                        delete newValue.attributes.start;
                      }
                    } else {
                      newValue.attributes = { start: startValue };
                    }
                  }
                  writer.removeAttribute('htmlPAttributes', element);
                  writer.setAttribute('htmlPAttributes', newValue, element);
                }
              } else {
                couldNotSetNumberLines.push(index + 1);
              }
            }
          });
          if (couldNotSetNumberLines.length > 0) {
            alert('N がない箇条書きリストのため、start 属性を変更できません。');
          }
          return;
        });
      });

      return button;
    });
  }
}
